import(/* webpackMode: "eager" */ "/app/src/app/(layout)/[slug]/error.tsx");
